module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /tmp/build_f0fbff5b/src/app/main/content/content.component.html
// module id = ../../../../../src/app/main/content/content.component.html
// module chunks = main